module.exports = __webpack_public_path__ + "static/media/Understanding.f346791d.jpeg";